module.exports = __webpack_public_path__ + "img/main_video_banner.ef8bd0f5.png";